<template>
  <div id="home" class="blog-categories">
    <my-header></my-header>
    <div class="pd20">
      <h3>{{'Manage tracking'|translate}}</h3>
      <div class="row mt20">
        <div class="col-xs-12 col-md-6 mt20">
          <div class="media">
            <div class="media-left">
              <img
                src="/static/images/trackings/block.jpg"
                class="media-object"
                style="width:100px"
              />
            </div>
            <div class="media-body media-middle">
              <p class="title">
                <router-link :to="{ name: 'ManageBlock'}">{{'Manage blocks'|translate}}</router-link>
              </p>

              <p>Quản lý khu vực đất trồng trong vườn của bạn</p>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 mt20">
          <div class="media">
            <div class="media-left">
              <img
                src="/static/images/trackings/period.jpg"
                class="media-object"
                style="width:100px"
              />
            </div>
            <div class="media-body media-middle">
              <p class="title">
                <router-link :to="{ name: 'ManagePeriod'}">{{'Manage periods'|translate}}</router-link>
              </p>

              <p>Quản lý lần trồng trong khu vực đất trồng</p>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 mt20">
          <div class="media">
            <div class="media-left">
              <img
                src="/static/images/trackings/season.jpg"
                class="media-object"
                style="width:100px"
              />
            </div>
            <div class="media-body media-middle">
              <p class="title">
                <router-link :to="{ name: 'ManageSeason'}">{{'Manage seasons'|translate}}</router-link>
              </p>

              <p>Quản lý mùa trong mỗi lần trồng</p>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 mt20">
          <div class="media">
            <div class="media-left">
              <img
                src="/static/images/trackings/tracking.jpg"
                class="media-object"
                style="width:100px"
              />
            </div>
            <div class="media-body media-middle">
              <p class="title">
                <router-link :to="{ name: 'ManageSerial'}">{{'Manage serials'|translate}}</router-link>
              </p>
              <p>Quản lý mã truy xuất để theo dõi quá trình canh tác</p>
            </div>
          </div>
        </div>
        <!-- end col-xs-6 -->
      </div>
    </div>
  </div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import FormBlock from "@/components/Cultivation/FormBlock";
import ManageSerial from "@/components/Cultivation/ManageSerial";
import Paginate from "vuejs-paginate";
import Loading from "@/components/elements/Loading";
export default {
  name: "ManageTracking",
  components: {
    MyHeader
  },
  data() {
    return {};
  },
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/Tracking/ManageTracking.vue